import type { ReactNode } from 'react';
import classNames from 'classnames';

export const Toast = ({ className, children, x = 'end', y = 'bottom' }: ToastProps) => {
    const toastClasses = classNames(
        'toast',
        x === 'center' ? 'toast-center' : '',
        x === 'end' ? 'toast-end' : '',
        x === 'start' ? 'toast-start' : '',
        y === 'bottom' ? 'toast-bottom' : '',
        y === 'middle' ? 'toast-middle' : '',
        y === 'top' ? 'toast-top' : '',
        className
    );

    return <div className={toastClasses}>{children}</div>;
};

interface ToastProps {
    className?: string;
    children?: ReactNode;
    x?: 'start' | 'center' | 'end';
    y?: 'top' | 'middle' | 'bottom';
}

export default Toast;
